import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_PIPELINE_ACCESS_ACTION_TYPE } from '../actions';

const initialState = {
  isLoaded: false,
  hasLoadFailed: false,
  roles: [],
  pipelines: [],
};

const subCompanyPipelineAccessReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_PIPELINE_ACCESS_ACTION_TYPE.GET_PIPELINE_ACCESS_REQUEST:
        draft.hasLoadFailed = false;
        break;

      case SUB_COMPANY_PIPELINE_ACCESS_ACTION_TYPE.GET_PIPELINE_ACCESS:
        return {
          isLoaded: true,
          hasLoadFailed: false,
          roles: payload?.roles || [],
          pipelines: payload?.pipelines || [],
        };

      case SUB_COMPANY_PIPELINE_ACCESS_ACTION_TYPE.GET_PIPELINE_ACCESS_FAILURE:
        draft.hasLoadFailed = true;
        break;

      case SUB_COMPANY_PIPELINE_ACCESS_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyPipelineAccessReducer;
